<template>
  <div>
    <div v-if="watermark" class="test-watermark" :style="watermarkStyle" aria-hidden="true"></div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    watermark() {
      if (window.systemData && window.systemData.watermark && window.systemData.watermark.text) return window.systemData.watermark.text;
      if (window.systemData && window.systemData.SYSTEM && window.systemData.SYSTEM.ifTest) return "TEST";
      else return false
    },
    watermarkColor() {
      const candidate = window.systemData && window.systemData.watermark && (window.systemData.watermark.color || window.systemData.watermark.colour);
      if (!candidate) return this.vuetifyPrimaryColor;

      const color = String(candidate).trim();
      const isHex = /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color);
      const isRgb = /^rgba?\((?:\s*\d{1,3}\s*,){2}\s*\d{1,3}(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)$/i.test(color);
      const isHsl = /^hsla?\((?:\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%)(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)$/i.test(color);

      return (isHex || isRgb || isHsl) ? color : this.vuetifyPrimaryColor;
    },
    vuetifyPrimaryColor() {
      const runtimePrimary = this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.currentTheme && this.$vuetify.theme.currentTheme.primary;
      if (runtimePrimary) return runtimePrimary;

      const cssPrimary = getComputedStyle(document.documentElement).getPropertyValue('--v-primary-base').trim();
      if (cssPrimary) return cssPrimary;

      // Safe Vuetify fallback when theme data is not yet available.
      return '#1976d2';
    },
    watermarkStyle() {
      if (!this.watermark) return {};

      const rawText = String(this.watermark).trim();
      const textLength = rawText.length || 1;

      // Keep the text readable while avoiding overlap when watermark is long.
      const fontSize = Math.max(18, Math.min(48, Math.round(56 - textLength * 0.9)));
      const padX = Math.max(40, Math.ceil(fontSize * 0.9));
      const padY = Math.max(24, Math.ceil(fontSize * 0.5));
      const tileWidth = Math.max(260, Math.ceil(fontSize * 0.62 * textLength + padX * 2));
      const tileHeight = Math.max(170, Math.ceil(fontSize * 2.4 + padY * 2));
      const cx = Math.round(tileWidth / 2);
      const cy = Math.round(tileHeight / 2);

      const escapedText = rawText
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');

      const svg = encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' width='${tileWidth}' height='${tileHeight}'><text x='50%' y='50%' text-anchor='middle' dominant-baseline='middle' font-family='Arial, sans-serif' font-size='${fontSize}' font-weight='bold' fill='${this.watermarkColor}' opacity='${window.systemData && window.systemData.watermark && window.systemData.watermark.opacity ? window.systemData.watermark.opacity : 0.05}' transform='rotate(-30 ${cx} ${cy})'>${escapedText}</text></svg>`
      );

      return {
        backgroundImage: `url("data:image/svg+xml,${svg}")`,
        backgroundSize: `${tileWidth}px ${tileHeight}px`
      };
    }
  },
  created() {
    let _ = this;
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (_.$pwa.pwaRsp.prompt !== false) _.$pwa.pwaRsp.prompt = e;
    });
    window.addEventListener("appinstalled", () => {
      _.$pwa.pwaRsp.prompt = false;
    });
  },
  methods: {

  }
}
</script>

<style>
.test-watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  background-repeat: repeat;
  background-size: 200px 150px;
}
</style>
